/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import themeConfig from '@/../themeConfig.js';
import colors from '@/../themeConfig.js';

const state = {
	isSidebarActive: true,
	breakpoint: null,
	sidebarWidth: 'default',
	reduceButton: themeConfig.sidebarCollapsed,
	bodyOverlay: false,
	sidebarItemsMin: false,
	theme: themeConfig.theme || 'light',
	themePrimaryColor: colors.primary,
	reduce: false,
	routerIndex: 0,
	isSystemReady: false,
	tourGuideActive: false,
	GuideStartedStep: 0,
	tourGuideRunning: false,
	GuideStartedStepV2: 0,
	GridInfo: {
		GridInvoice: {}
	},
	isLoadingTotalAmountPage: false,
	TakeItem: 20,
	isLoadingPushData: false,
	updateIdentificationPopupActive: false
};

export default state;
